import { FC, ReactNode, useEffect, useMemo, useState } from 'react';
import { useMemberLazyQuery } from 'lib/graphql/generated';
import hasMemberIdCookie from 'utils/hasMemberIdCookie';
import QffUserContext, { QffUser } from './QffUserContext';

interface Props {
  children: ReactNode;
}

const QffUserProvider: FC<Props> = ({ children }) => {
  const [qffUser, setQffUser] = useState<QffUser | null>(null);

  const [authenticateUser, { data, error, loading }] = useMemberLazyQuery({
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!hasMemberIdCookie()) {
      return;
    }

    authenticateUser({
      context: {
        skipUnauthenticatedRedirection: true,
      },
    });
  }, [authenticateUser]);

  useEffect(() => {
    if (data?.member && !error) {
      const { memberId, title, firstName, lastName, pointsBalance, membershipTier } = data.member;
      setQffUser({
        memberId,
        title,
        firstName,
        lastName,
        pointsBalance: pointsBalance?.toString() || '0',
        membershipTier,
      });
    }

    if (error) {
      setQffUser(null);
    }
  }, [data, error]);

  const value = useMemo(
    () => ({
      qffUser,
      isLoading: loading,
    }),
    [qffUser, loading],
  );

  return <QffUserContext.Provider value={value}>{children}</QffUserContext.Provider>;
};

export default QffUserProvider;
